import * as React from "react";
import {cs} from "../../../../../../../../../react/chain-services";
import {keyed} from "../../../../../../../../../react/keyed";
import {stateChangeNestedValue} from "../../../../../../../../../react/state-change-nested-value";
import {CheckboxLine} from "../checkbox-line/checkbox-line";

export const CheckboxType = ({fieldConfig, state, key, next}) => cs(
    ({}) => {
        return next({
            controls: ({showErrors}) => (
                <>
                    {Object.values(fieldConfig.values).map((field, i) => cs(
                        keyed(i),
                        () => CheckboxLine({
                            state: {
                                value: state.value[key + "_" + field],
                                onChange: (v) => stateChangeNestedValue(state, [key + "_" + field], () => v),
                            },
                            text: field,
                            textUI: {blur: true},
                            xdQaName: "Demographics Search "+field,
                        })
                    ))}
                </>
            ),
        });
    },
);
